import Label from "./Label";
import { theme } from "../../theme.js";

export default function Select({name, label, dict, value, setFormData, required=false, width="100%"}) {
    return (
        <div style={styles.selectWrapper}>
            <Label label={label} required={required}/>
            <div/>
            <select
                name={name}
                value={value}
                onChange={(e) => setFormData((s) => ({ ...s, [name]: e.target.value }))}
                style={{ ...styles.select, width }}
                required={required}
            >
                <option value="">Sélectionner</option>
                {Object.entries(dict).map(([key, val]) => (
                    <option key={key} value={key}>{val}</option>
                ))}
            </select>
        </div>
    );
}

const styles = {
    selectWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: 2,
  },
  select: {
    padding: "10px 12px",
    borderRadius: 6,
    border: `1px solid ${theme.colors.border}`,
    fontSize: 14,
    width: "100%",
    boxSizing: "border-box",
    fontFamily: "inherit",
    backgroundColor: "#fff",
  },
};